import React, { useState } from 'react';
import { Container, Header, ExpandButton, IconContainer } from '../../Tabs.styles';
import CustomTitle from '../../../CustomTitle/index';
import { Grid, Image, ImageContainer, StackOverlay, StackItem } from './CollapsibleGallery.styles';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { setSelectedItem, setSelectedSegment } from '../../../../../redux/reducers/newhotbar';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import IyugaTooltip from '../../../../IyugaTooltip';
import EmptyContent from '../../../EmptyContent';

const CollapsibleGallery = ({ images = [], icon, title, segmentId, segmentColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    if (images.length > 3) {
      setIsExpanded(!isExpanded);
    }
  };

  // Number of images to display
  const visibleImages = isExpanded ? images : images.slice(0, 3);
  const dispatch = useDispatch();

  // Handler to open the overlay and set the selected image and array
  const handleImageClick = (imageSrc, imageArray) => {
    dispatch(
      setSelectedItem({
        title: title,
        type: 'images',
        item: imageSrc,
      })
    );
    dispatch(
      setSelectedSegment({
        segmentId: segmentId,
      })
    );
  };

  if (images.length === 0) {
    return <EmptyContent />;
  }

  return (
    <Container>
      {/* Header Section: Title and Expand Button */}
      <Header>
        <IconContainer bgColor={segmentColor}>{/* <FaChevronUp />  */}</IconContainer>
        <CustomTitle title={title} count={images.length} />
        <ExpandButton showIcon={images.length > 3} onClick={toggleExpand}>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </ExpandButton>
      </Header>

      {/* Image Grid */}
      <Grid>
        {visibleImages.map((image, index) => (
          <ImageContainer key={index}>
            <Image src={image?.src} alt={`Gallery Image ${index + 1}`} />
            <StackOverlay className="stack-overlay">
              <StackItem>
                <IyugaTooltip tooltip={'Preview'}>
                  <RemoveRedEyeIcon
                    style={{ color: '#5A1B97' }}
                    onClick={() => handleImageClick(image, visibleImages)}
                  />
                </IyugaTooltip>
              </StackItem>
              {/* <StackItem>
                <IyugaTooltip tooltip={'Open Image'}>
                  <OpenInNewIcon
                    style={{ color: '#5A1B97' }}
                    onClick={() => window.open(image?.src, '_blank')} // Opens link in a new tab
                  />
                </IyugaTooltip>
              </StackItem> */}
            </StackOverlay>
          </ImageContainer>
        ))}
      </Grid>
    </Container>
  );
};

export default CollapsibleGallery;
